// extracted by mini-css-extract-plugin
export default {"progressBar":"sal_progressBar__YiQbk"};